export default __webpack_public_path__ + "static/stephanie-d32db11a68c2b29d8db5c9fcb0086524.jpg";